import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';
import { ProgressionModelSource } from 'features/wildfires/wildfire.types';

type UseProgressionModelsSources = Omit<
  UseQueryResult<ProgressionModelSource[], Error>,
  'data'
> & {
  progressionModelsSources: ProgressionModelSource[];
};

const fetchProgressionModelsSources = async (): Promise<
  ProgressionModelSource[]
> => {
  const response = await API.get<ProgressionModelSource[]>(
    'fire_progression_models/sources/',
  );
  return response.data;
};

export const useProgressionModelsSources = (): UseProgressionModelsSources => {
  const { data = [], ...results } = useQuery({
    queryKey: ['progressionModelsSources'],
    queryFn: () => fetchProgressionModelsSources(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours,
  });

  return { ...results, progressionModelsSources: data };
};
